import { createSelector } from '@ngrx/store';

import { eplusHeatpumpsFeature } from '../heatpumps.state';
import { heatpumpsFunnelKey } from './heatpumps-funnel.reducer';

export const selectHeatpumpsFunnelSettings = createSelector(
  eplusHeatpumpsFeature,
  (state) => state[heatpumpsFunnelKey]
);
